import { render } from "./MountProduct.vue?vue&type=template&id=cb5315e2"
import script from "./MountProduct.vue?vue&type=script&lang=js"
export * from "./MountProduct.vue?vue&type=script&lang=js"

import "./MountProduct.vue?vue&type=style&index=0&id=cb5315e2&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__